<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:11rem; margin: 0 0.625rem;" v-model="theNeighbor" placeholder="选择小区" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  @change="queryData">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<a-button    icon="search" @click="queryDataList" style="margin-left: 0.625rem;">查找</a-button>
			<a-button    icon="file" @click="exportData" style="margin: 0 0.625rem;" :loading="exportLoading">导出</a-button>
			<span style="color:red">统计口径: 统计某小区最近一次抄表读数和一个月前抄表读数相差超过50的用户，以及本次抄表读数小于上次抄表读数的用户</span>
		</div>
		<a-table size="small" :columns="columns" :data-source="dataList"  bordered  rowKey="CID"  :loading="loading"
					  :pagination="false" :scroll="{y:600}">
		</a-table>			  
	</div>
</template>

<script>
	export default{
		data(){
			const  columns = [
				{
					title: '水费号',
					dataIndex: 'CID',
					width:80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户号',
					dataIndex: 'customerNum',
					width:80,
					className:'v-cell',
					align:'center',
					
				},
				{
					title: '用户名',
					dataIndex: 'CustomerName',
					width:90,
					className:'v-cell',
					align:'center',
				},
				{
					title: '手机',
					dataIndex: 'CustomerMobile',
					width:90,
					className:'v-cell',
					align:'center',
				},
				{
					title: '地址',
					dataIndex: 'CustomerAddr',
					width:150,
					className:'v-cell',
					align:'center',
				},
				{
					title: '钢印号',
					dataIndex: 'SteelNum',
					width:120,
					className:'v-cell',
					align:'center',
				},
				{
					title: '表地址',
					dataIndex: 'MeterAddr',
					width:150,
					className:'v-cell',
					align:'center',
				},
				{
					title: '本次抄表读数',
					dataIndex: 'readdata',
					width:100,
					className:'v-cell',
					align:'center',
				},
				{
					title: '上次抄表读数',
					dataIndex: 'lastReadData',
					width:100,
					className:'v-cell',
					align:'center',
				},
				{
					title: '异常原因',
					dataIndex: 'reason',
					width:120,
					className:'v-cell',
					align:'center',
				},
			];	
			return{
				columns,
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				loading:false,
				exportLoading:false,
			}
		},
		methods:{
			exportData:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_ABNORMAL_CUSTOMER_EXPORT_URL);
				let param = {neighborId:this.theNeighbor.key,neighborName:this.theNeighbor.label};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = this.theNeighbor.label+'.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryDataList:function(){
				if(this.theNeighbor ==undefined){
					this.$message.error('请选择小区');
					return;
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_ABNORMAL_CUSTOMER_LIST_URL);
				let param = {neighborId:this.theNeighbor.key};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
